import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Navbar from '../components/common/Navbar';
import MyBrands from '../components/brands/MyBrands';

export default function Brands() {
  const main = useRef();

  return (
    <>
      <Helmet>
        <title>My Brands - NarrativeOS</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
      </Helmet>
      <LoadingScreen />
      <Cursor />
      <ProgressScroll />
      <Lines />
      <Navbar />
      <div id="smooth-wrapper" ref={main}>
        <div id="smooth-content">
          <main className="main-bg o-hidden">
            <header className="page-header bg-img section-padding valign" data-background="/assets/imgs/background/bg4.jpg" data-overlay-dark="8">
              <div className="container pt-80">
                <div className="row">
                  <div className="col-12">
                    <div className="text-center">
                      <h1 className="text-u ls1 fz-80">
                        My <span className="fw-200">Brands</span>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="container section-padding">
              <MyBrands />
            </div>
          </main>
        </div>
      </div>
    </>
  );
} 